import { Membership } from '@/types/api/membership';
import { MembershipListItem } from '../components/membership-list';

export const membershipToListItem = (membership: Membership): MembershipListItem => ({
  user: membership.user!.name,
  userId: membership.userId,
  status: membership.status,
  roles: membership.roles,
});
